<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #nohomefilter>
    @if(mode() === 'nohomesmall') {
    {{zielText()}}
    } @else {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
</ng-template>

<ng-template #homemodeMobile>
    <div class="searchBoxWrapper_mobile customflex" #mdbuttondesk="cdkOverlayOrigin"
        [class.searchBoxWrapperactive]="showModal()" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
        (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">Zimmertype</span>
            <div class="searchinputwrapper">
                <input type="text" placeholder="{{showModal() ? '': zielText()}}" [class.inputactive]="showModal()"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()" class="searchinput">
                @if(mySearchControl?.value?.length > 0) {
                <button (click)="clearText()" class="closesection">
                    <img src="../../../../assets/tvg/close.svg" alt="close">
                </button>
                }
            </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <div class="searchBoxWrapper" #mdbuttondesk="cdkOverlayOrigin" [class.searchBoxWrapperactive]="showModal()"
        cdkOverlayOrigin (click)="openModal()" ng-clickOutside (clickOutside)="closeModal()">
        <div class="wrapper">
            <span class="description">Zimmertype</span>
            <div class="searchinputwrapper">
                <input type="text" placeholder="{{showModal() ? '': zielText()}}" [class.inputactive]="showModal()"
                    [formControl]="mySearchControl" ng-focus [appAutoFocus]="focus()" class="searchinput">
                @if(mySearchControl?.value?.length > 0) {
                <button (click)="clearText()" class="customsize">
                    <img src="../../../../assets/tvg/close.svg" alt="close">
                </button>
                }
            </div>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>

    <!-- <div class="searchBoxWrapper" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin (click)="openModal($event)">
        <div class="wrapper">
            <span class="description">Zimmertype</span>
            <p>{{zielText}}</p>
        </div>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template> -->
</ng-template>


<ng-template #modal>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="mobileDesk"></ng-container>
    }
    }
</ng-template>


<ng-template #mobileDesk>
    <div class="custompopupwrapper mat-elevation-z1">
        <div class="popupbody">
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile">
        <div class="filterwrapper-mobile">
            <button class="shettheader" (click)="closeModalMobile()" #searchheader>
                <img src="../../../../../assets/tvg/leftdirection.svg" alt="goback icon">
                <span>Zimmertype?</span>
            </button>
            <div class="searchBoxWrapper customflex" #mdbuttondesk="cdkOverlayOrigin"
                [class.searchBoxWrapperactive]="showModal()" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
                (clickOutside)="closeModal()">
                <div class="wrapper" (click)="$event.stopPropagation()">
                    <span class="description">Zimmertype</span>
                    <div class="searchinputwrapper">
                        <input type="text" placeholder="{{showModal() ? '': zielText()}}"
                            [class.inputactive]="showModal()" [formControl]="mySearchControl" ng-focus
                            [appAutoFocus]="focus()" class="searchinput">
                        @if(mySearchControl?.value?.length > 0) {
                        <button (click)="clearText()" class="closesection">
                            <img src="../../../../assets/tvg/close.svg" alt="close">
                        </button>
                        }
                    </div>
                </div>
            </div>
            <div class="custompopupwrapper-mobile">
                <div class="popupbody">
                    <ng-container *ngTemplateOutlet="datassection"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper customscroll" (click)="$event.stopPropagation()">
        @if(selectedList()?.length > 0) {
        <div class="selected-wrapper">
            <button class="selected-item-alle" (click)="removeAllSelected()">
                <span>{{'Alles löschen'}}</span>
            </button>
            @for (item of selectedList(); let k = $index; track k) {
            <div class="selected-item">
                <span>{{item.name}} <span class="second-item-line">{{item.code}}</span></span>
                <button (click)="removeFromSelected(k)">
                    <mat-icon class="clearbtn">clear</mat-icon>
                </button>
            </div>
            }
        </div>
        }
        @if(mySearchControl?.value?.length > 0 && (searchObj | async); as zimmer) {
        @for (item of zimmer; track $index) {
        @if(isNotInlist(item)) {
        <button class="item-wrapper" (click)="selectValue(item)">
            <div class="item-body">
                <span class="first-item-line">{{item.name}} <span class="second-item-line">{{item.code}}</span></span>
            </div>
        </button>
        }
        }
        } @else {
        <div class="customchipwrapper">
            @if(selectedList()?.length > 0) {
            <button class="custopmchip" (click)="removeAllSelected()">
                <span>beliebig</span>
            </button>
            } @else {
            <button class="custopmchip_active" (click)="removeAllSelected()">
                <img src="../../../../assets/tvg/checked.svg" alt="checked">
                <span>beliebig</span>
            </button>
            }
        </div>
        <div class="searchresbody">
            <div class="titlewrp">
                <span class="stattitle">Beliebte Zimmer</span>
            </div>
            <div class="customchipwrapper">
                @for (item of beliebig_zimmer; track $index) {
                @if(isNotInlist(item)) {
                <button class="custopmchip" (click)="addZimmer($event, item)">
                    <span>{{item.name}} ({{item.code}})</span>
                </button>
                } @else {
                <button class="custopmchip_active" (click)="addZimmer($event, item)">
                    <img src="../../../../assets/tvg/checked.svg" alt="checked">
                    <span>{{item.name}} ({{item.code}})</span>
                </button>
                }
                }

            </div>
        </div>
        }
    </div>
    <div class="ubwrapper">
        <button class="custombutton customunfilled w50" (click)="take()">Übernehmen {{selectedList()?.length > 0 ? '(' +
            selectedList().length + ')' : ''}}</button>
    </div>
</ng-template>